import { stateSetter } from '@/utils';

export enum AuthState {
	Loading,
	SignedOut,
	SignedIn,
	NoAccess
}

// `neighborhoodModerator` = cetățean promovat moderator al cartierului lui (BE: api/users/me →
// moderatedNeighborhood); nu are rol de staff, vede doar pagina cartierului său.
export type UserRole =
	| 'superadmin'
	| 'admin'
	| 'moderator'
	| 'fsp'
	| 'neighborhoodModerator'
	| undefined;

/** Drepturile pe care un moderator de cartier le poate primi (BE: NeighborhoodModeratorPermissions). */
export type NeighborhoodModeratorRight = 'announcements' | 'surveys' | 'chat';

/** Cartierul moderat de utilizatorul curent și drepturile lui în el (din api/users/me). */
export interface IModeratedNeighborhood {
	id: number;
	name: string;
	shortName: string;
	isArchived: boolean;
	permissions: NeighborhoodModeratorRight[];
}

interface IAuthPermission {
	id: number;
	key: string;
	module: string;
}

export interface IAuthRole {
	id: number;
	name: string;
	// Eticheta localizată de afișare (BE); `name` rămâne identificatorul intern.
	label?: string;
	description?: string;
	permissions?: IAuthPermission[];
}

export interface IUser {
	id: number;
	role: UserRole;
	email: string;
	firstName: string;
	lastName: string;
	phone?: string;
	countryCode?: string;
	isLoggedIn?: boolean;
	/** URL simplu (istoric) sau obiectul de asset din users/me — afișare via avatarUrlOf. */
	avatar?: string | { id?: number; fileName?: string; publicUrl?: string | null };
	/** Flattened permission keys (e.g. "projects:read") from the user's roles. */
	permissions?: string[];
	/** Setat doar pentru moderatorii de cartier — singurul cartier pe care îl pot deschide. */
	moderatedNeighborhood?: IModeratedNeighborhood;
	metadata?: {
		coverPhoto?: string;
		institutionAvatar?: string;
	};
}

export interface IAuthContext {
	authState: AuthState;
	availableRoles: IAuthRole[];
	/** Încarcă lazy lista de roluri (GET api/roles) — o singură dată, la cerere. NU se mai
	 *  cere la bootstrap: userii fără `roles:read` nu depind de ea ca să pornească aplicația. */
	loadAvailableRoles: () => void;
	user: IUser | undefined;
	signIn: () => void;
	signOut: () => Promise<void>;
	refreshAuthState: (authState: AuthState) => void;
	setUser: stateSetter<IUser | undefined>;
	/** Sesiunea a expirat (user inactiv / refresh eșuat / 401) → afișăm modala de expirare. */
	sessionExpired: boolean;
	/** CTA-ul modalei: curăță sesiunea și trimite utilizatorul spre re-autentificare. */
	returnToLogin: () => void;
}
